import axios from 'axios';
import { authStore } from '../stores/authStore';
import toast from 'react-hot-toast';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token
api.interceptors.request.use(
  (config) => {
    const token = authStore.getState().token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para tratar erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      authStore.getState().logout();
      window.location.href = '/login';
      toast.error('Sessão expirada. Faça login novamente.');
    } else if (error.response?.status === 403) {
      toast.error('Você não tem permissão para esta ação');
    } else if (error.response?.status === 500) {
      toast.error('Erro no servidor. Tente novamente.');
    }
    return Promise.reject(error);
  }
);

// CloudQI Integration APIs
export const cloudqiApi = {
  // Busca usuário CloudQI por email
  getUserByEmail: (email) => 
    api.get(`/integracoes/cloudqi/user/${email}`),
  
  // Busca dispositivos organizados por casas e salas do usuário CloudQI
  getDevicesByUserId: (userId) => 
    api.get(`/integracoes/cloudqi/devices/${userId}`),
  
  // Busca dados detalhados de uma casa específica
  getHomeDetailed: (homeId) => 
    api.get(`/integracoes/cloudqi/home/${homeId}/detailed`)
};

export default api;